// ObjectLine — a thing the assistant made, as one line in the thread (pen
// "Chat – every entry" §7): its glyph, title, kind and size, then Open. The
// work lives at the object; this line only points there. Used for a material
// made and an export ready. Pure: Open is offered only when wired.

import { Trans } from "@lingui/react/macro";
import type { ReactNode } from "react";
import { Icon, type IconName } from "../../Icon/Icon.js";
import "./ObjectLine.css";

export const ObjectLine = ({
    icon,
    title,
    detail,
    onOpen,
}: {
    readonly icon: IconName;
    readonly title: string;
    readonly detail: string;
    readonly onOpen?: () => void;
}): ReactNode => (
    <div className="bilda-object-line">
        <Icon name={icon} className="bilda-object-line__glyph" />
        <div className="bilda-object-line__text">
            <span className="bilda-object-line__title">{title}</span>
            <span className="bilda-object-line__detail">{detail}</span>
        </div>
        {onOpen === undefined ? null : (
            <button
                type="button"
                className="bilda-object-line__open"
                onClick={onOpen}
            >
                <Trans>Open</Trans>
            </button>
        )}
    </div>
);
